
import PropTypes from 'prop-types'
import React from 'react'
import css from './index.module.css'

const CircularLogo = props => {
  return (
    <div className={css.main}>
      <img src={props.logo} alt={props.alt} />
    </div>
  )
}

CircularLogo.propTypes = {
  main: PropTypes.string,
  alt: PropTypes.string.isRequired
}

CircularLogo.displayName = 'CircularLogo'

export default CircularLogo



// WEBPACK FOOTER //
// ./ui/CircularLogo/index.js